import React from "react";
import PropTypes from "prop-types";
import { Grid, GridRow } from "semantic-ui-react";
import HomepageSignpost from "./homepage-signpost";
import HomepageWidgets from "./homepage-widgets";

const HomePageView = ({ config }) => {
  return (
    <Grid divided="vertically">
      <GridRow columns={1}>
        <HomepageSignpost />
      </GridRow>
      <GridRow>
        <HomepageWidgets />
      </GridRow>
    </Grid>
  );
};

HomePageView.propTypes = {
  config: PropTypes.object,
};

export default HomePageView;
